import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';
import { PrivateContent, Roles } from '@/js/libs/use-auth';

import { ROUTER } from 'src/AppRouter';
import { DEV_MODE, SUPPORT_EMAIL } from 'src/constants';

export const SupportButton: FC = () => {
  const [t] = useTranslation(['common', 'components']);

  const mailToSupport = useCallbackRef(() => {
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  });

  const openUsersnap = useCallbackRef(() => {
    window.Usersnap?.logEvent('open_usersnap');
  });

  return (
    <DropdownList
      minWidth={false}
      dataTestId='support-button'
      renderButton={() => (
        <Button iconOnly ghost title={t('common:SUPPORT')}>
          <Icons.Headphones size={20} />
        </Button>
      )}>
      {DEV_MODE && (
        <PrivateContent roles={Roles.SUPPORT_CENTER}>
          <DropdownList.DropdownItem icon={<Icons.Draft />} to={ROUTER['/support-center/tickets'].path.pattern} dataTestId='tickets-button'>
            {t('components:TICKETS')}
          </DropdownList.DropdownItem>
        </PrivateContent>
      )}
      <DropdownList.DropdownItem icon={<Icons.Mail />} onClick={mailToSupport} dataTestId='contact-us-button' tooltip={SUPPORT_EMAIL}>
        {t('common:CONTACT_US')}
      </DropdownList.DropdownItem>
      <DropdownList.DropdownItem icon={<Icons.MouseCursor />} onClick={openUsersnap} dataTestId='usersnap-button'>
        {t('common:USERSNAP')}
      </DropdownList.DropdownItem>
    </DropdownList>
  );
};
